<template>
	<div class="container">
		<mt-popup
            v-model="isShowAttrInfo"
            position="bottom"
            v-bind:close-on-click-modal="false"
		>
        <div class="attr-wrapper">
            <div class="attr-header"><span class="title">参数</span><span class="iconfont close" v-on:click="closeAttrInfo(false)">&#xe65a;</span></div>
            <div class="attr-item">
                <flex-line v-for="(item,index) in goodsattr" ><span class="line-name">{{item.name}}</span><span slot="right">{{item.value}}</span></flex-line>
            </div>
        </div>
		</mt-popup>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import flexLine from '../../../flexLine'
export default {
  components:{
    flexLine
  },
  data () {
    return {
      
    }
  },

  props: {
    isShowAttrInfo: {
      type: Boolean,
      default: false
    }
  },

  created () {
	  
  },

  computed: {
    ...mapState({
      goodsattr: state => state.goodsdetail.detailInfo.goods_attr
    }),
  },


  mounted () {
  },

  methods: {
    ...mapActions({
      getGoodsDetail: 'getGoodsDetail'
    }),
    ...mapMutations({
      saveAttrState: 'saveAttrState'
    }),

    // 关闭购物车浮层
    closeAttrInfo (value) {
      this.saveAttrState(value)
    },

    
  }
}
</script>

<style lang="scss" scoped>
	.mint-popup-bottom {
		overflow: initial;
		height: 80%;
        border-radius: 0.25rem 0.25rem 0 0;
	}
    .attr-wrapper{
        background: rgba(255, 255, 255, 1);
        height: 100%;
        position: absolute;
        width: -webkit-fill-available;
        /* bottom: 0; */
        z-index: 10;
        width: 100%;
        border-radius: 0.25rem 0.25rem 0 0;
        padding: 1rem $pageSpace 0;
        box-sizing: border-box;
        .attr-header{
            display: flex;
            align-items: center;
            .title{
                font-size: .8rem;
            }
            .close{
                margin-left: auto;
            }
        }
        .attr-item{
            border-radius: .4rem;
            padding: $pageSpace;
            margin-top: .5rem;
        }
    }
    

</style>
